import {
  coalescePlainTextToEditorV2Html,
  EditorV2,
  EditorV2State,
  MaudCardFrame,
} from '@equip.health/ui';
import { useEffect, useRef } from 'react';
import { PatientReadonlyNoteCollapse } from '~/components/maud/patients/profile/tabs/patientNotesTab/PatientReadonlyNoteCollapse';

type Props = {
  noteExternalId: string;
  sessionSummary: string;
};

export const PatientNoteItemSessionSummary = ({
  noteExternalId,
  sessionSummary,
}: Props) => {
  const sessionSummaryEditorRef = useRef<EditorV2State>(null);

  const htmlSessionSummary: string | null = sessionSummary
    ? coalescePlainTextToEditorV2Html(sessionSummary)
    : null;

  useEffect(() => {
    sessionSummaryEditorRef.current
      ?.chain()
      .setContent(htmlSessionSummary)
      .run();
  }, [htmlSessionSummary]);

  return (
    <PatientReadonlyNoteCollapse title="Session Summary">
      <MaudCardFrame id={`note-session-summary-${noteExternalId}`}>
        <EditorV2
          hideBorder
          initialContent={htmlSessionSummary}
          readOnly
          stateRef={sessionSummaryEditorRef}
        />
      </MaudCardFrame>
    </PatientReadonlyNoteCollapse>
  );
};
